import React from 'react';
import styles from 'styles/admin-detail.module.scss';

import AsyncButton from 'utils/AsyncButton';
import CloseIcon from '@material-ui/icons/Close';
import { NON_FINANCIAL_FORM_TYPE, NON_FINANCIAL_MESSAGE_TYPE } from "const";

const FreeChatInputConfirm = (props) => {
  const { freeChatInputFormik, isFreeChatSubmitInProgress, closeModal, canSend } = props;

  return (
    <>
      <CloseIcon
        fontSize='large'
        className={styles.closeImg}
        onClick={closeModal}
      />
      <div className={styles.confirmPage}>
        <p className={styles.labelTop}>チャット種別</p>
        <p className={styles.text}>{NON_FINANCIAL_MESSAGE_TYPE[freeChatInputFormik.values.messageType]}</p>
      </div>
      <div className={styles.confirmPage}>
        <p className={styles.labelTop}>LINEメッセージ</p>
        <p className={styles.text}>{freeChatInputFormik.values.freeMessage}</p>
      </div>
      {(freeChatInputFormik.values.messageType !== 7) && (
        <>
          <div className={styles.confirmPage}>
            <p className={styles.labelTop}>回答フォーム種別</p>
            <p className={styles.text}>{NON_FINANCIAL_FORM_TYPE[freeChatInputFormik.values.type]}</p>
          </div>
          <div className={styles.confirmPage}>
            <p className={styles.labelTop}>回答フォームメッセージ</p>
            <p className={styles.text}>{freeChatInputFormik.values.message || '-'}</p>
          </div>
        </>
      )}
      {canSend && (
        <div className={styles.displayRight}>
          <AsyncButton
            className={styles.confirmButton}
            type='button'
            color='primary'
            variant='contained'
            onClick={() => freeChatInputFormik.handleSubmit()}
            loading={isFreeChatSubmitInProgress}
          >
            送信
          </AsyncButton>
        </div>
      )}
    </>
  );
};

export default FreeChatInputConfirm;
